<template>
    <div>
        <slot></slot>

        <div class="form-row">
            <div class="form-group col-sm-6">
                <input
                    type="text"
                    name="address.firstname"
                    v-model="addressData.firstname"
                    class="form-control input-gray"
                    :placeholder="$t('Generic.firstname')"
                    required
                    :aria-label="$t('Generic.firstname')"
                />
            </div>
            <div class="form-group col-sm-6">
                <input
                    type="text"
                    name="address.lastname"
                    v-model="addressData.lastname"
                    class="form-control input-gray"
                    :placeholder="$t('Generic.lastname')"
                    required
                    :aria-label="$t('Generic.lastname')"
                />
            </div>
        </div>

        <slot name="middle"> </slot>

        <template v-if="extended">
            <div class="form-row">
                <div class="form-group col">
                    <input
                        type="text"
                        name="additionalAddressLine"
                        v-model.lazy="addressData.additionalAddressLine"
                        class="form-control input-gray"
                        :placeholder="$t('Generic.additionalAddressLine')"
                        :aria-label="$t('Generic.additionalAddressLine')"
                    />
                </div>
            </div>

            <div class="form-row">
                <div class="form-group col-lg-8">
                    <input
                        type="text"
                        name="street"
                        v-model.lazy="addressData.street"
                        class="form-control input-gray"
                        :placeholder="$t('Generic.streetAndNumber')"
                        required
                        :aria-label="$t('Generic.streetAndNumber')"
                        :title="$t('Generic.streetAndNumber')"
                        minlength="3"
                        pattern="^[^0-9]{2,}?.*$"
                    />

                    <span v-if="streetLacksNumber">
                        <small class="text-danger">{{ $t('AddressInput.houseNumberProof') }}</small>
                    </span>
                </div>
                <div class="form-group col-4 col-lg-4">
                    <input
                        type="text"
                        name="zipcode"
                        v-model.lazy="addressData.zipcode"
                        inputmode="numeric"
                        maxlength="5"
                        minlength="5"
                        pattern="\d*"
                        class="form-control input-gray"
                        :placeholder="$t('Generic.zipcode')"
                        required
                        :aria-label="$t('Generic.zipcode')"
                    />
                </div>
                <div class="form-group col-8 col-lg-6">
                    <input
                        type="text"
                        name="city"
                        v-model.lazy="addressData.city"
                        class="form-control input-gray"
                        :placeholder="$t('Generic.city')"
                        required
                        :aria-label="$t('Generic.city')"
                    />
                </div>
                <div class="form-group col-lg-6">
                    <select
                        v-model="addressData.country"
                        name="country"
                        class="form-control input-gray custom-select"
                        aria-label="Land"
                    >
                        <option value="DE">{{ $t('Country.Germany') }}</option>
                    </select>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'AddressInputs',
    props: {
        addressData: {
            type: Object,
            default() {
                return {};
            }
        },
        extended: {
            Boolean
        }
    },
    computed: {
        streetLacksNumber() {
            return this.addressData.street && !this.addressData.street.match(/\d/);
        }
    },
    watch: {
        extended: {
            handler(extended) {
                if (extended) {
                    Object.assign(this.addressData, {
                        country: 'DE'
                    });
                } else {
                    delete this.addressData.country;
                }
            },
            //immediate to support ShippingAddress extended flag already being set
            immediate: true
        }
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';
@include variables.ie {
    input {
        height: 50px;
    }
}
</style>
